import React, { useContext, useEffect, useState } from "react";
import style from "./style.module.scss";
import { CustomButton } from "../../../../../common/components/CustomButton/CustomButton";
import { IoIosAddCircleOutline } from "react-icons/io";
import CustomModal from "../../../../../common/components/Modal/CustomModal";
import { NewTeam } from "./NewTeam";
import { PlanningContext } from "./PlanningForm";
import { RiDeleteBin5Line } from "react-icons/ri";
import { MdOutlineEdit } from "react-icons/md";
import { Select, Tag, TimePicker } from "antd";
import { CustomPopConfirm } from "../../../../../common/components/PopConfirm/CustomPopConfirm";
import { OperationContext } from "../CreateOperation";
import { PlanningConstant } from "../../../core/_constant";
import { InputSelect } from "../../../../../common/components/InputSelect/InputSelect";
import { API_URLs } from "../../../../../utilities/API_URLs";

type TypeInterface = {
  label: string;
  value: string;
};

type OnBoardTeamType = {
  boardType: TypeInterface;
  allTeams: Array<any>;
};

export const OnBoardTeam = ({ allTeams, boardType }: OnBoardTeamType) => {
  const { RangePicker } = TimePicker;

  const {
    // allTeams,
    handleDeleteTeamValue,
    onChangeHoldsHandler,
    onChangeTimeLine,
    // errorMessage,
    postAndRefreshData,
    isDisableForm,
    onChangeInput,
  } = useContext(PlanningContext);
  const { initialValue } = useContext(OperationContext);

  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<any>(null);
  const [isOpenConfirm, setIsOpenConfirm] = useState<boolean>(false);
  const [holdsOptions, setHoldsOptions] = useState<Array<any>>([]);
  const [selectedValue, setSelectedValue] = useState<any>(null);
  const [selectedIndex, setSelectedIndex] = useState<any>(null);

  // useEffect(() => {
  //   setHoldsHandler(allTeams);
  // }, [allTeams]);
  useEffect(() => {
    setHoldsOptions(
      initialValue?.holds?.map((item: number) => ({
        label: `${item}`,
        value: item,
      }))
    );
  }, [initialValue]);

  useEffect(() => {
    if (!isOpenModal) {
      setSelectedValue(null);
    }
  }, [isOpenModal]);

  // const setHoldsHandler = (teams: Array<any>) => {
  //   setOldsOptions([]);
  //   let selected: Array<number> = [];
  //   allTeams?.forEach((team: any) => {
  //     let newSel: Array<number> = [];
  //     team?.holds?.forEach((item: any) => {
  //       newSel = [...newSel, item?.value];
  //     });
  //     selected = [...selected, ...newSel];
  //   });

  //   Array.from({ length: teams?.length })?.forEach((_: any, index: number) => {
  //     const myHolds = teams[index]?.holds?.map((i: any) => i?.value);

  //     setOldsOptions((h: any) => [
  //       ...h,
  //       {
  //         holds: initialValue?.holds
  //           ?.filter(
  //             (item: any) =>
  //               !selected
  //                 ?.filter((sel: number) => !myHolds?.includes(sel))
  //                 ?.includes(item)
  //           )
  //           ?.map((item: number) => ({
  //             label: item,
  //             value: item,
  //           })),
  //       },
  //     ]);
  //   });
  // };

  const handleShowModal = (e?: any) => {
    e && e?.preventDefault();
    setIsOpenModal((prev: boolean) => !prev);
  };

  const handleShowPopConfirm = () => {
    setIsOpenConfirm((prev: boolean) => !prev);
  };

  const handleClickOnDelete = (idClicked: number) => {
    setSelectedId(idClicked);
    handleShowPopConfirm();
  };

  const handleConfirmDelete = () => {
    handleDeleteTeamValue(selectedId, boardType.value);
    setSelectedId(null);
    handleShowPopConfirm();
  };

  const handleChangeHolds = (value: any, key: number) => {
    const formatedData = {
      key,
      value,
    };
    onChangeHoldsHandler(formatedData, boardType.value);
    setSelectedId(null);
  };

  const handleChangeTimes = (value: any, key: number) => {
    const formatedData = {
      key,
      value: {
        teamShiftStart: value[0],
        teamShiftEnd: value[1],
      },
    };
    onChangeTimeLine(formatedData, boardType.value);
  };

  const handleChanges = (value: any, key: number) => {
    const formatedData = {
      key,
      value,
    };
    onChangeInput(formatedData, boardType.value);
  };

  const onClickOnEdit = (item: any, index: number) => {
    setSelectedValue(item);
    setSelectedIndex(index);
    handleShowModal();
  };

  const onPostAndRefreshDataHandler = () => {
    postAndRefreshData();
  };

  return (
    <>
      <div>
        <div className={style.planning__subtitle_container}>
          <div className="">
            <span className={style.planning__subtitle}>{boardType.label}</span>
          </div>

          <CustomButton
            className="d-flex align-items-center gap-2"
            backgroundColor="#55acee"
            onClick={handleShowModal}
            disabled={isDisableForm}
          >
            <IoIosAddCircleOutline className={style.planning__subtitle_icon} />

            {`Nouvelle équipe`}
          </CustomButton>
        </div>

        <div className={style.board__item_wrapper}>
          {allTeams?.map((item: any, key: number) => (
            <div className={style.board__item_container} key={key}>
              <div className={style.board__item_header}>
                <div className="">
                  <p className={style.board__item_title}> {item?.name} </p>
                </div>
                <div className={style.board__item_action_container}>
                  <div
                    className={style.board__item_delete}
                    onClick={() => onClickOnEdit(item, key)}
                  >
                    <MdOutlineEdit
                      title="Modifier"
                      className={style.board__item_delete_icon}
                    />
                  </div>

                  <CustomPopConfirm
                    title="Voulez-vous vraiment enlever cette équipe ?"
                    okText="Oui"
                    cancelText="Non"
                    isOpen={isOpenConfirm && selectedId === key}
                    onClose={handleShowPopConfirm}
                    onConfirm={handleConfirmDelete}
                  >
                    <div
                      className={style.board__item_delete}
                      onClick={() => handleClickOnDelete(key)}
                    >
                      <RiDeleteBin5Line
                        title="Supprimer"
                        className={style.board__item_delete_icon}
                      />
                    </div>
                  </CustomPopConfirm>
                </div>
              </div>
              <div className={style.board__item_content}>
                <div className={style.board__item_content_container}>
                  <div className={style.board__item_input_time}>
                    <span className={style.board__item_input_label}>
                      {"Horaire (Début - Fin)"}{" "}
                    </span>
                    <RangePicker
                      placeholder={["Début", "Fin"]}
                      format={"HH:mm"}
                      needConfirm={false}
                      value={[item?.teamShiftStart, item?.teamShiftEnd]}
                      onChange={(e: any) => handleChangeTimes(e, key)}
                      disabled={isDisableForm}
                    />
                  </div>
                  {boardType?.value === PlanningConstant.TEAM_ON_BOARD_ID ? (
                    <div className={style.board__item_input_wrapper}>
                      <span className={style.board__item_input_label}>
                        {"Cale"}{" "}
                      </span>
                      <Select
                        mode="multiple"
                        labelInValue
                        value={item?.holds}
                        disabled={isDisableForm}
                        // options={holdsOptions?.[key]?.["holds"]}
                        options={holdsOptions}
                        onChange={(e: any) => handleChangeHolds(e, key)}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {boardType?.value === PlanningConstant.TEAM_DOCKSIDE_ID ? (
                    <div className={style.board__item_input_wrapper}>
                      <span className={style.board__item_input_label}>
                        {"Lieu d'affectation"}{" "}
                      </span>
                      <InputSelect
                        uri={`${API_URLs.operations.planning.assignementLocation}`}
                        value={item?.assignmentLocation}
                        onChange={(e) => {
                          handleChanges(
                            {
                              assignmentLocation: e?.value,
                            },
                            key
                          );
                        }}
                        disabled={isDisableForm}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {item?.modelTeamStaff?.map((staffTeam: any, index: number) => (
                  <div className={style.board__item_input_wrapper} key={index}>
                    <span className={style.board__item_input_label}>
                      {staffTeam?.name}{" "}
                    </span>
                    <div className={style.board__item_input}>
                      {staffTeam?.staff?.map((staff: any) => (
                        <Tag bordered={false} color="processing">
                          {staff?.fullname}
                        </Tag>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {isOpenModal ? (
        <CustomModal
          isShowCloseIcon={false}
          width={800}
          isOpen={isOpenModal}
          hanldeCloseModal={handleShowModal}
        >
          <NewTeam
            onClose={handleShowModal}
            onSuccess={onPostAndRefreshDataHandler}
            teamType={boardType.value}
            {...(selectedValue
              ? {
                  initialValue: selectedValue,
                  index: selectedIndex,
                }
              : {})}
          />
        </CustomModal>
      ) : (
        ""
      )}
    </>
  );
};
